export const formatOrder = (arrayToSetOrder) =>
  arrayToSetOrder
    ?.filter((item) => item)
    ?.sort((a, b) => a.order - b.order)
    ?.map((item, index) => ({ ...item, order: index + 1 }));
